// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

interface XProductDetailsPartNumberStyles {
    labelText?: TypographyPresentationProps;
    valueText?: TypographyPresentationProps;
}

export const xProductDetailsPartNumberStyles: XProductDetailsPartNumberStyles = {
    labelText: {
        size: 15,
        weight: "bold",
        lineHeight: "24px",
        css: css`
            letter-spacing: 0;
            &:after {
                content: ":";
            }
        `,
    },
    valueText: {
        size: 15,
        lineHeight: "24px",
        css: css`
            margin: 0 0 4px 8px;
            letter-spacing: 0;
        `,
    },
};
